var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgHero4 = function SvgHero4(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 124 338",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_4_svg__linear-gradient",
    x1: -10.4572,
    y1: 65.15,
    x2: 111.9601,
    y2: 276.2143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#67c6a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4cc2c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8067,
    stopColor: "#7cacc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95a1cc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_4_svg__radial-gradient",
    cx: -37.3043,
    cy: 28.2582,
    r: 154.4966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0289,
    stopColor: "#00aca8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5946,
    stopColor: "#2ad19f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e89a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_4_svg__radial-gradient-2",
    cx: -78.4581,
    cy: 100.2195,
    r: 265.4047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe47d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fc2bf"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_4_svg__radial-gradient-3",
    cx: 13.5434,
    cy: 372.1154,
    r: 120.1059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dc6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2204,
    stopColor: "#51c4be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4438,
    stopColor: "#5dbfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6687,
    stopColor: "#72b6c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8932,
    stopColor: "#8eaac7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ea3c9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_4_svg__radial-gradient-4",
    cx: 17.4787,
    cy: 304.2649,
    r: 148.3867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2762,
    stopColor: "#27bcbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7678,
    stopColor: "#68c7c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81cbc5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_4_svg__radial-gradient-5",
    cx: -50.5108,
    cy: 149.2825,
    r: 98.6866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b6e473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3fbfc4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_4_svg__radial-gradient-6",
    cx: 20.1699,
    cy: 256.422,
    r: 200.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3898,
    stopColor: "#42c0a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8041,
    stopColor: "#83cb9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ccf99"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_4_svg__radial-gradient-7",
    cx: 126.1505,
    cy: 230.2802,
    r: 139.6287,
    xlinkHref: "#hero_4_svg__radial-gradient-6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_4_svg__radial-gradient-8",
    cx: 181.6327,
    cy: 227.8113,
    r: 104.9169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#787dd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#7b81d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5606,
    stopColor: "#858dd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8437,
    stopColor: "#95a1cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1b0c9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_4_svg__radial-gradient-9",
    cx: 111.8407,
    cy: 212.1064,
    r: 214.7103,
    xlinkHref: "#hero_4_svg__radial-gradient-6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_4_svg__radial-gradient-10",
    cx: 41.7143,
    cy: 228.6487,
    r: 71.0786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2762,
    stopColor: "#27b1b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7678,
    stopColor: "#68aac1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81a7c5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_4_svg__radial-gradient-11",
    cx: 107.7446,
    cy: 74.2889,
    r: 160.5164,
    xlinkHref: "#hero_4_svg__radial-gradient-6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "hero_4_svg__hero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hero_4_svg__lower-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hero_4_svg__bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.1148,86.5074,114.23,173.8368l.9672,65.9822q2.9016,12.6142,5.8033,25.2285L58.1311,332q-7.7376-30.08-15.4754-60.16L17.5082,196.1543c-3.8172-30.989-7.1034-63.36-9.6721-97.0326Q4.3935,53.9938,3,11.7923L15.5738,5,75.541,68.0712Z",
    style: {
      fill: "url(#hero_4_svg__linear-gradient)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "hero_4_svg__shapes_shard_03"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,0,0,8,6,96,27,20Z",
    style: {
      fill: "url(#hero_4_svg__radial-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,64,90,84l-3,9q-23.5,48.5-47,97Q55.5,131.5,71,73Z",
    style: {
      fill: "url(#hero_4_svg__radial-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,285l-3,5L58,333l-1,5,67-70Z",
    style: {
      fill: "url(#hero_4_svg__radial-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,207q8,34.5,16,69,.5,4.5,1,9-9.5,26.5-19,53L42,277q1-6,2-12Z",
    style: {
      fill: "url(#hero_4_svg__radial-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,96l2,1,34,88q.5,4.5,1,9v76q-.5,3.5-1,7L16.5,196.5Z",
    style: {
      fill: "url(#hero_4_svg__radial-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5,185.5,46,189l13,19v2q-8.5,33.5-17,67Q41.75,231.25,41.5,185.5Z",
    style: {
      fill: "url(#hero_4_svg__radial-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,210,41.5,185.5Q65.75,134.75,90,84q13,45.5,26,91l-4,4L64,208Z",
    style: {
      fill: "url(#hero_4_svg__radial-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,175l-9,17L79,273l-2.9454,12.3272L124,268q-3.2858-13.6647-6.5716-27.3293Z",
    style: {
      fill: "url(#hero_4_svg__radial-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,20,6,96l35.5,89.5L76,64c-4.343-4.6109-9.0036-9.2941-14-14A331.6543,331.6543,0,0,0,28,22Z",
    style: {
      fill: "url(#hero_4_svg__radial-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,210q8.5,38,17,76l40-111Z",
    style: {
      fill: "url(#hero_4_svg__radial-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,0,76,64,24,20Z",
    style: {
      fill: "url(#hero_4_svg__radial-gradient-11)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "hero_4_svg__highlights-5",
    "data-name": "highlights",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,196l12,46L15,198q-2.5-30.5-5-61Q14,166.5,18,196Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,224q6.5,31,13,62-4,12-8,24l10-24,27-11-26,9,30-89L76,284Q69,254,62,224Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,185l-8-20,8,21q.5,12,1,24V187l7,9-7-10,6-23Z",
    style: {
      fill: "#f2f2f2"
    }
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgHero4);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hero_4.722b8b5e25f1bb8b94c7d295db4191db.svg";